// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e296ad97","453":"fe137238","667":"dab6252d"}[chunkId] + ".chunk.js";
};